import 'antd/dist/antd.css';
import 'bootstrap/dist/css/bootstrap.css';
import Head from 'next/head';
import { Provider } from 'react-redux';
import '../styles/bootstrap-cheatsheet.css';
import '../styles/globals.css';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/footer';
import store from '../store/Store';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { hasCookie } from 'cookies-next';
import IdleTimerContainer from '../Helper/AutoLogoutTimer';
import ProtectedRoutes from '../Helper/ProtectedRoutes';
import { NEXT_API_URL_title } from '../Helper/Config';
import Script from 'next/script';
import { NotificationProvider } from '../Helper/NotificationContext';
import Maintenance from './maintenance';
function MyApp({ Component, pageProps, router }) {
  const routers = useRouter();
  let persistor = persistStore(store);
  const[maintenanceMode,setMaintenanceMode] = useState();
  const [message, setMessage] = useState();

  // const showHeader =
  //   routers.pathname === '/' ||
  //   routers.pathname === '/ManageCompany' ||
  //   routers.pathname === '/ManageRole' ||
  //   routers.pathname === '/Celcom_dashboard' ||
  //   routers.pathname === '/ManageNotifications' ||
  //   routers.pathname === '/FAQ'
  //     ? // ||
  //       // (Object.keys(user).length === 0 && routers.pathname === '/support')
  //       false
  //     : true;
  // const showFooter = routers.pathname === '/' ? false : true;
  // routers.pathname === '/Popup' ? false : true;
  // const userLoggedIn = hasCookie('AUTHKEY', true);
  // const userLoggedIn2 = hasCookie('AUTHKEY2', true);

  const hideHeaderRoutes = [
    '/',
    '/ManageCompany',
    '/ManageRole',
    '/Celcom_dashboard',
    '/ManageNotifications',
    '/FAQ',
  ];
  const showHeader = !hideHeaderRoutes.includes(routers.pathname);
  const showFooter = !['/', '/Popup'].includes(routers.pathname);

  const isUserLoggedIn = hasCookie('AUTHKEY') || hasCookie('AUTHKEY2');
 // const maintenanceMode = false; // Change this flag to false when done

 useEffect(() => {
  getMaintenanceStatus();
 },[]);

 async function getMaintenanceStatus (){
  try {
      const response = await fetch("/bizcareui/api/maintenanceStatus", {
        method: "GET",
        headers: {
          'Content-Type': "application/json",
        },
      });

      if (response.ok) {
        const result = await response.json();
        setMessage(result?.message);
        setMaintenanceMode(result?.enabled || false); // Default to false if undefined
      } else {
        
        setMaintenanceMode(false); // Default to false on API error
      }
    } catch (fail) {
     
      setMaintenanceMode(false); // Default to false on network error
    } 

 }

  if (maintenanceMode) {
    return <Maintenance message={message}/>;
  }
  return (
    <div className="grandParentContainer">
      <div>
        <Head>
          <title>BizCare</title>
          <link
            rel="icon"
            type="image/png"
            // href={`${NEXT_API_URL_title}/CelcomFavicon32x32.png`}
            href={`${NEXT_API_URL_title}/CelcomDigi_Favicon.png`}
          />
          <meta charSet="UTF-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <Script
            async
            defer
            src="https://celcomdesign.gitlab.io/system/bootstrap/examples.6b1909d7.js"
          />
          <Script
            async
            defer
            src="https://celcomdesign.gitlab.io/system/bootstrap/examples.f31f9a96.js"
          />
          <Script
            async
            defer
            src="https://celcomdesign.gitlab.io/system/bootstrap/examples.9c28c8cf.js"
          />
          <Script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"></Script>
        </Head>
      </div>

      <NotificationProvider>
        <Provider store={store}>
          {isUserLoggedIn && <IdleTimerContainer />}
          <PersistGate loading={null} persistor={persistor}>
            <ProtectedRoutes router={router}>
              <div className="parentContainer">
                {showHeader && <Header />}
                <Component {...pageProps} />
                {showFooter && <Footer />}
              </div>
            </ProtectedRoutes>
          </PersistGate>
        </Provider>
      </NotificationProvider>
    </div>
  );
}

export default MyApp;
